import axios from 'axios'

const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? 'https://qmv-report-api.huestimates.net'
    : '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

export const reportApi = {
  // Client-in məlumatlarını al
  getClientByToken(token) {
    return api.get(`/Report/GetClientInfo?publicToken=${token}`)
  },

  // Client-in sessiyalarının hesabatını al
  getClientSessions(token) {
    return api.get(`/Report/GetClientSessions?publicToken=${token}`)
  },

  // Sessiyanın məkan statistikasını al
  getSessionLocations(sessionId) {
    return api.get(`/Report/GetSessionLocations?sessionId=${sessionId}`)
  },

  // Sessiyanın məhsul növü statistikasını al
  getSessionProducts(sessionId) {
    return api.get(`/Report/GetSessionProducts?sessionId=${sessionId}`)
  }
}

export default api
